import { generalConstants } from '@tweddle-se-team/common/constants'
import { serviceWarrantySearch } from '@tweddle-se-team/common/helpers'
import { buildServiceWarrantyQuery } from './helpers'

const { WTY, contentTypes, SEARCH_RESULT_TYPES } = generalConstants

export const mergePublicationSearchResults = (responses, partNumbers) => {
  const results = partNumbers?.length
    ? responses
        .flat()
        .filter(
          item => item.promoted || item.type !== SEARCH_RESULT_TYPES.PUBLICATION || partNumbers.includes(item.title)
        )
    : responses[0]
  const recommendation = results.find(item => item.publicationType === WTY && item.promoted)
  return serviceWarrantySearch.promoteServiceWarrantyResult(results, recommendation)
}

export const buildServiceWarrantySearchQuery = (item, routerQuery, vehicle) => {
  const query = buildServiceWarrantyQuery(
    { ...routerQuery, ...vehicle },
    item.product.year,
    item.isHTML ? contentTypes.dita : contentTypes.webview
  )
  // A manual's line-off date must not restrict the country-specific warranty selected on the next page.
  delete query.lineOffDate
  return query
}
